import * as Immutable from "immutable";
export default class QueryMetadata {
  constructor(usedParameterNames) {
    this._value = { usedParameterNames };
  }
  get usedParameterNames() {
    return this._value.usedParameterNames;
  }
  static fromJSON(value) {
    return new QueryMetadata(Immutable.Set(value.used_parameters_names));
  }
}
